import { useNavigate } from 'react-router-dom'
import { AlertCircle, Home } from 'lucide-react'

export function AccessDenied() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-4">
        <div className="text-center">
          {/* Error Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
              <AlertCircle className="w-10 h-10 text-destructive" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Access Denied
          </h1>

          {/* Message */}
          <p className="text-muted-foreground mb-8">
            You don't have permission to access this page. If you believe this is an error, please contact your administrator.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 rounded-lg border border-border bg-background hover:bg-muted transition-colors font-medium"
            >
              Go Back
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-6 py-2.5 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors font-medium inline-flex items-center justify-center gap-2"
            >
              <Home className="w-4 h-4" />
              Dashboard
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-muted/50 rounded-lg">
            <p className="text-sm text-muted-foreground">
              If you need access to this page, please reach out to your company administrator or{" "}
              <a href="mailto:support@securesight.ai.com" className="text-primary hover:underline">
                support@securesight.ai.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
